/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';

/**
 * GoogleIcon Component
 *
 * Renders Google's official multi-color "G" logomark as an inline SVG, since
 * a font-icon glyph (e.g. Bootstrap Icons' bi-google) can only ever be a
 * single, theme-tinted color and can't reproduce Google's real brand colors.
 * Path data matches upvibe's ic_google_logo.xml exactly, so the logo is
 * pixel-identical between the mobile app and this web client.
 *
 * Props:
 * - size: (number) width/height in pixels. Defaults to 18 to match the
 *   existing bi-google glyph's rendered size in SignInForm/SignUpForm.
 */
const GoogleIcon = ({ size = 18, style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: 8, flexShrink: 0, ...style }}
  >
    <path
      fill="#4285F4"
      d="M45.12,24.5c0,-1.56 -0.14,-3.06 -0.4,-4.5H24v8.51h11.84c-0.51,2.75 -2.06,5.08 -4.39,6.64v5.52h7.11c4.16,-3.83 6.56,-9.47 6.56,-16.17z"
    />
    <path
      fill="#34A853"
      d="M24,46c5.94,0 10.92,-1.97 14.56,-5.33l-7.11,-5.52c-1.97,1.32 -4.49,2.1 -7.45,2.1 -5.73,0 -10.58,-3.87 -12.31,-9.07H4.34v5.7C7.96,41.07 15.4,46 24,46z"
    />
    <path
      fill="#FBBC05"
      d="M11.69,28.18C11.25,26.86 11,25.45 11,24s0.25,-2.86 0.69,-4.18v-5.7H4.34C2.85,17.09 2,20.45 2,24s0.85,6.91 2.34,9.88l7.35,-5.7z"
    />
    <path
      fill="#EA4335"
      d="M24,10.75c3.23,0 6.13,1.11 8.41,3.29l6.31,-6.31C34.91,4.18 29.93,2 24,2 15.4,2 7.96,6.93 4.34,14.12l7.35,5.7c1.73,-5.2 6.58,-9.07 12.31,-9.07z"
    />
  </svg>
);

export default GoogleIcon;
